import React from "react";
import { useHistory, useParams } from "react-router-dom";
import URL from "../../../constant/URL";
import Button from "../../common/Button";

const Footer = ( props ) => {

  const history = useHistory();
  const params = useParams();

  const jumpAnsweringQuestions = () => {
    history.replace(`${URL.QUESTION_INSPECTION.ANSWERING_QUESTIONS }/inspect/${ params.stageCode }` );
  };

  return (
    <div className="footer">
      <div className="footer_inne_lr cls">
        <div className="left">
          <Button className="btn btn-red btn1" onClick={ props.onShowConceptCheckPlayer }>개념 확인하기</Button>
        </div>
        <div className="right">
          <Button className="btn btn-blue" onClick={ jumpAnsweringQuestions }>시작하기</Button>
        </div>
      </div>
    </div>
  );

};

Footer.defaultProps = {
  onShowConceptCheckPlayer : () => {}
};

export default Footer;
